import {
  FormControl,
  InputLabel,

  TextField,
} from "@mui/material";
import React, { Dispatch, RefObject, useState } from "react";
import { FormInput } from "../../../lib/workout-form/transformers";
import { Action, FormInputs } from "../../../reducers/workoutReducer";

type Props = {
  dispatch: Dispatch<Action>;
  loading: boolean;
  body: FormInput;
  handleErrorRefs: RefObject<(() => void)[]>;
};

const BodyInput = ({ handleErrorRefs, dispatch, loading, body }: Props) => {
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const handleError = () => {
    setError(body.error);
    setMessage(body.message);
  };
  handleErrorRefs.current?.push(handleError);

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel
        sx={{ backgroundColor: "white" }}
        htmlFor="body"
        error={false}></InputLabel>

      <TextField
        multiline
        id="body"
        label="Övrigt"
        value={body.input}
        minRows={2}
        maxRows={2}
        onChange={(e) =>
          dispatch({ type: FormInputs.body, payload: e.target.value })
        }
        disabled={loading}
        onBlur={handleError}
        error={error}
        helperText={message}
      />
    </FormControl>
  );
};

export default BodyInput;
